/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBatteryDto
 */
export interface GetBatteryDto {
    /**
     * 
     * @type {string}
     * @memberof GetBatteryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetBatteryDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBatteryDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBatteryDto
     */
    tests?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBatteryDto
     */
    articlePsychologistsIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBatteryDto
     */
    articleDoctorsIds?: Array<string> | null;
}

/**
 * Check if a given object implements the GetBatteryDto interface.
 */
export function instanceOfGetBatteryDto(value: object): value is GetBatteryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetBatteryDtoFromJSON(json: any): GetBatteryDto {
    return GetBatteryDtoFromJSONTyped(json, false);
}

export function GetBatteryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBatteryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'tests': json['tests'] == null ? undefined : json['tests'],
        'articlePsychologistsIds': json['articlePsychologistsIds'] == null ? undefined : json['articlePsychologistsIds'],
        'articleDoctorsIds': json['articleDoctorsIds'] == null ? undefined : json['articleDoctorsIds'],
    };
}

export function GetBatteryDtoToJSON(value?: GetBatteryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'tests': value['tests'],
        'articlePsychologistsIds': value['articlePsychologistsIds'],
        'articleDoctorsIds': value['articleDoctorsIds'],
    };
}

